// Global "Patient is waiting" incoming-call modal for the doctor portal (§2).
// Shown from anywhere the moment a patient joins a consultation before the doctor.
import React from "react";
import { Video, Phone, MessageSquare, PhoneOff, LogIn } from "lucide-react";
import Avatar from "../ui/Avatar";

const MODE_ICON = { video: Video, voice: Phone, chat: MessageSquare };
const MODE_LABEL = { video: "Video", voice: "Voice", chat: "Chat" };

export default function IncomingCallModal({ call, onJoin, onDismiss }) {
  if (!call) return null;
  const from = call.from || {};
  const name = from.name || "Patient";
  const mode = call.mode || "video";
  const ModeIcon = MODE_ICON[mode] || Video;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/70 backdrop-blur-sm p-4">
      <div className="w-full max-w-sm rounded-3xl bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 shadow-2xl p-7 text-center">
        <p className="text-xs font-semibold uppercase tracking-wide text-emerald-600 dark:text-emerald-400">
          Patient is waiting
        </p>

        <div className="mt-5 mb-4 flex justify-center">
          <span className="relative inline-flex">
            <span className="absolute inset-0 rounded-full bg-emerald-400/30 animate-ping" />
            <span className="relative">
              <Avatar src={from.photoUrl} name={name} size="lg" />
            </span>
          </span>
        </div>

        <h2 className="text-xl font-semibold text-slate-900 dark:text-white">{name}</h2>
        <p className="mt-1 inline-flex items-center gap-1.5 text-sm text-slate-500 dark:text-slate-400">
          <ModeIcon size={14} /> Incoming {MODE_LABEL[mode] || mode} consultation
        </p>

        <div className="mt-7 flex items-center justify-center gap-3">
          <button
            onClick={onDismiss}
            className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 text-sm font-medium"
          >
            <PhoneOff size={16} /> Dismiss
          </button>
          <button
            onClick={onJoin}
            className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold shadow-sm"
          >
            <LogIn size={16} /> Join now
          </button>
        </div>
      </div>
    </div>
  );
}
